import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaPaperPlane,
  FaAngleDown,
  FaTruck,
  FaWrench,
  FaTools,
  FaExclamationTriangle,
  FaBars,
  FaTimes,
} from "react-icons/fa";

import logo from "../assets/logo2.svg";
import "./Navbar.css";

function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const location = useLocation();

  // Close mobile menu + dropdown when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false);
  }, [location.pathname]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest(".dropdown")) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  // Handle scroll event (no unused state warnings)
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        document.body.classList.add("scrolled");
      } else {
        document.body.classList.remove("scrolled");
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.body.classList.remove("scrolled");
    };
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [isMobileMenuOpen]);

  const handleServiceClick = () => {
    setIsDropdownOpen(false);
    setIsMobileMenuOpen(false);
  };

  return (
    <header id="header-outer">
      <div id="header-main" className="sticky">
        <div className="container main-nav">
          {/* Logo */}
          <div className="logo">
            <Link to="/" onClick={closeMobileMenu}>
              <img src={logo} alt="Car Forensics Logo" />
            </Link>
          </div>

          {/* Hamburger Menu Toggle */}
          <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </div>

          {/* Nav Links */}
          <nav className={`main-menu ${isMobileMenuOpen ? "active" : ""}`}>
            <ul>
              <li>
                <Link to="/" onClick={closeMobileMenu}>Home</Link>
              </li>

              <li>
                <Link to="/about" onClick={closeMobileMenu}>About Us</Link>
              </li>

              <li
                className="dropdown"
                onMouseEnter={() => window.innerWidth > 768 && setIsDropdownOpen(true)}
                onMouseLeave={() => window.innerWidth > 768 && setIsDropdownOpen(false)}
                onClick={() => window.innerWidth <= 768 && toggleDropdown()}
              >
                {/* Keep <a> EXACTLY like your original for style */}
                <a
                  href="/"
                  className="dropdown-trigger"
                  onClick={(e) => e.preventDefault()}
                >
                  Our Services{" "}
                  <FaAngleDown
                    className={`dropdown-icon ${isDropdownOpen ? "rotated" : ""}`}
                  />
                </a>

                <div className={`dropdown-container ${isDropdownOpen ? "active" : ""}`}>
                  <div className="dropdown-content new-style">
                    <h3 className="dropdown-heading">Our Services</h3>

                    <div className="services-grid">
                      <Link
                        to="/ecu-remapping"
                        className="service-card"
                        onClick={handleServiceClick}
                      >
                        <FaWrench className="service-card-icon" />
                        <h4>ECU Remapping</h4>
                        <p>Professional engine tuning & performance upgrades.</p>
                      </Link>

                      <Link
                        to="/programming"
                        className="service-card"
                        onClick={handleServiceClick}
                      >
                        <FaTools className="service-card-icon" />
                        <h4>Programming & Coding</h4>
                        <p>Vehicle software programming and coding services.</p>
                      </Link>

                      <Link
                        to="/diagnostic"
                        className="service-card"
                        onClick={handleServiceClick}
                      >
                        <FaExclamationTriangle className="service-card-icon" />
                        <h4>Diagnostic</h4>
                        <p>Advanced vehicle diagnostic and troubleshooting.</p>
                      </Link>

                      <Link
                        to="/car-service"
                        className="service-card"
                        onClick={handleServiceClick}
                      >
                        <FaWrench className="service-card-icon" />
                        <h4>Car Service</h4>
                        <p>Complete vehicle servicing and maintenance packages.</p>
                      </Link>

                      <Link
                        to="/recovery"
                        className="service-card"
                        onClick={handleServiceClick}
                      >
                        <FaTruck className="service-card-icon" />
                        <h4>Recovery Services</h4>
                        <p>Professional vehicle recovery and assistance.</p>
                      </Link>
                    </div>
                  </div>
                </div>
              </li>

              <li>
                <Link to="/contact" onClick={closeMobileMenu}>Contact Us</Link>
              </li>

              <li className="mobile-quote-btn">
                <Link to="/contact" onClick={closeMobileMenu}>
                  <FaPaperPlane /> Get a Quote
                </Link>
              </li>
            </ul>
          </nav>

          {/* Call for Quote Button */}
          <div className="quote-btn desktop-quote-btn">
            <Link to="/contact">
              <FaPaperPlane /> Get a Quote
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
